import React, { useState } from 'react';
import { Navbar as BootstrapNavbar, Container, Nav, Dropdown, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { Menu, Bell, User, LogOut, Settings, ChevronDown } from 'lucide-react';
import useAuth from '../../hooks/useAuth';

const Navbar = ({ toggleSidebar }) => {
    const { user, logout } = useAuth();
    const navigate = useNavigate();
    const [showNotifications, setShowNotifications] = useState(false);

    const handleLogout = () => {
        logout();
    };

    return (
        <BootstrapNavbar bg="white" expand="lg" className="border-bottom shadow-sm py-2">
            <Container fluid>
                <Button
                    variant="link"
                    className="p-0 me-3 d-lg-none"
                    onClick={toggleSidebar}
                >
                    <Menu size={24} />
                </Button>

                <BootstrapNavbar.Brand href="/dashboard" className="fw-bold">
                    <span style={{ fontSize: '24px' }}>SEN OSCAR</span> {/* Texte au lieu de l'image */}
                </BootstrapNavbar.Brand>




                <Nav className="ms-auto d-flex flex-row align-items-center">
                    {/* Notifications dropdown */}
                    {/* <Dropdown align="end" className="me-3">
                        <Dropdown.Toggle
                            as="div"
                            className="nav-link position-relative"
                            style={{ cursor: 'pointer' }}
                        >
                            <Bell size={20} />
                            <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                                2
                            </span>
                        </Dropdown.Toggle>

                        <Dropdown.Menu style={{ minWidth: '300px' }}>
                            <Dropdown.Header>Notifications</Dropdown.Header>
                            <Dropdown.Item className="d-flex align-items-center py-2">
                                <div className="rounded-circle bg-primary p-2 me-3">
                                    <Bell size={16} color="white" />
                                </div>
                                <div>
                                    <p className="mb-0 fw-semibold">Nouvelle commande</p>
                                    <small className="text-muted">Il y'a 30 mn</small>
                                </div>
                            </Dropdown.Item>
                            <Dropdown.Item className="d-flex align-items-center py-2">
                                <div className="rounded-circle bg-warning p-2 me-3">
                                    <Bell size={16} color="white" />
                                </div>
                                <div>
                                    <p className="mb-0 fw-semibold">Low stock alert</p>
                                    <small className="text-muted">2 hours ago</small>
                                </div>
                            </Dropdown.Item>
                            <Dropdown.Divider />
                            <Dropdown.Item className="text-center">
                                <small>Voir toutes les notifications</small>
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown> */}

                    {/* User profile dropdown */}
                    <Dropdown align="end">
                        <Dropdown.Toggle
                            as="div"
                            className="nav-link d-flex align-items-center"
                            style={{ cursor: 'pointer' }}
                        >
                            <div className="rounded-circle bg-light p-1 me-2">
                                <User size={24} />
                            </div>
                            <div className="d-none d-sm-block">
                                <div className="fw-semibold">{user?.fullName || 'User'}</div>
                                <div className="small text-muted">
                                    {user?.roles?.includes('ROLE_ADMIN') ? 'Administrateur' :
                                        user?.roles?.includes('ROLE_MANAGER') ? 'Manager' :
                                            user?.roles?.includes('ROLE_SALES_REP') ? 'Commercial' :
                                                user?.roles?.includes('ROLE_DISTRIBUTOR') ? 'Distributeur' :
                                                    user?.roles?.includes('ROLE_WAREHOUSE_MANAGER') ? 'Warehouse Manager' : 'User'}
                                </div>
                            </div>
                            <ChevronDown size={16} className="ms-2" />
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <Dropdown.Item onClick={() => navigate('/profile')}>
                                <User size={16} className="me-2" />
                                Profil
                            </Dropdown.Item>
                            {/* <Dropdown.Item onClick={() => navigate('/settings')}>
                                <Settings size={16} className="me-2" />
                                Paramètres
                            </Dropdown.Item> */}
                            <Dropdown.Divider />
                            <Dropdown.Item onClick={handleLogout}>
                                <LogOut size={16} className="me-2" />
                                Se déconnecter
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </Nav>
            </Container>
        </BootstrapNavbar>
    );
};

export default Navbar;